import React from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { useNavigate } from 'react-router-dom';
import {
  TargetIcon,
  UserIcon,
  UsersIcon,
  PirateIcon,
  FencingSwordsIcon,
  ChartBarIcon,
  TrophyIcon,
  MedalIcon,
  TrendingUpIcon,
  SmartphoneIcon,
  LightbulbIcon,
  ScheduleIcon
} from '../components/FencingIcons';

const GuidePage = () => {
  const navigate = useNavigate();

  // Componente per le sezioni della guida
  const GuideSection = ({ title, content, icon: Icon }) => (
    <View style={styles.section}>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16, borderBottomWidth: 1, borderBottomColor: '#e0e0e0', paddingBottom: 8 }}>
        <Icon style={{ fontSize: 28, color: '#1976d2', marginRight: 10 }} />
        <Text style={[styles.sectionTitle, { marginBottom: 0, borderBottomWidth: 0, paddingBottom: 0 }]}>{title}</Text>
      </View>
      <Text style={styles.sectionContent}>{content}</Text>
    </View>
  );

  return (
    <ScrollView style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>Guida all'uso di 123 Scherma!</Text>
        <Text style={styles.subtitle}>Gestisci gare di scherma a squadre, individuali e miste con facilità</Text>
      </View>

      <TouchableOpacity
        style={styles.backButton}
        onPress={() => navigate('/')}
      >
        <Text style={styles.backButtonText}>← Torna alla Home</Text>
      </TouchableOpacity>

      <GuideSection
        icon={TargetIcon}
        title="Panoramica dell'App"
        content={`123 Scherma! è un'app completa per la gestione di competizioni di scherma. Supporta:

• Gare Individuali con gironi e eliminazione diretta
• Gare a Squadre (formati simmetrici e asimmetrici)
• Squadre Miste con configurazione flessibile
• Segnapunti indipendente per arbitraggio rapido`}
      />

      <GuideSection
        icon={UserIcon}
        title="Gara Individuale"
        content={`Per atleti singoli con gironi + eliminazione:

1. Tocca "Gara Individuale" dalla home
2. Inserisci i nomi di tutti i partecipanti
3. Configura il numero di gironi manualmente
4. Imposta stoccate per girone (default: 5) e eliminazione (default: 15)
5. Puoi impostare uno sbarramento per le dirette
6. È possibile spostare atleti tra gironi dopo la creazione`}
      />

      <GuideSection
        icon={UsersIcon}
        title="Gara a Squadre"
        content={`Crea una competizione tra squadre:

1. Dalla home, tocca "Gara a Squadre"
2. Inserisci i nomi delle squadre
3. Per ogni squadra, aggiungi i tiratori
4. Decidi ogni quante stoccate c'è il cambio assalto
5. Configura il numero di stoccate totali per girone (default: 45)

Ordine assalti:
• L'ordine determina la sequenza di chiusura dell'incontro
• Puoi cambiare l'ordine con drag & drop dalla schermata configurazione
• Nel segnapunti, usa l'icona ⚙️ in alto per modificare ordine e registrare sostituzioni`}
      />

      <GuideSection
        icon={PirateIcon}
        title="Squadre Miste"
        content={`Per formazioni con composizione variabile:

1. Tocca "Squadre Miste" dalla home
2. Seleziona categorie di preset o creane di nuove
3. Decidi se gli assalti si alternano o vanno in ordine (l'ordine determina la chiusura)
4. Supporta formati simmetrici e asimmetrici
5. È possibile cambiare l'ordine anche dopo aver inserito i nomi`}
      />

      <GuideSection
        icon={ScheduleIcon}
        title="Elenco Assalti"
        content={`Gestisci tutti gli incontri della competizione:

• Tocca un match per inserire i punteggi
• I pulsanti + / - modificano rapidamente il punteggio
• Il match si completa automaticamente al raggiungimento del limite
• Tocca la card di un match per aprire il segnapunti

Filtri disponibili:
• Seleziona solo un girone specifico o tutti
• Filtra solo i match ancora da tirare
• Cerca direttamente il nome di un tiratore`}
      />

      <GuideSection
        icon={FencingSwordsIcon}
        title="Segnapunti"
        content={`Strumento per l'arbitraggio in tempo reale:

• Tocca il riquadro del punteggio per aumentare (+1)
• Usa il pulsante "-" per diminuire
• Cartellini: Giallo (avvertimento) / Rosso (punto avversario)
• Usa la doppia freccia ⇄ tra i nomi per invertire i lati
• Gestisci la vittoria per tempo
• Torna alla schermata assalti quando hai finito

Per le squadre:
• Usa l'icona ⚙️ in alto per modificare l'ordine degli assalti
• Da lì puoi anche registrare le sostituzioni (riserve)`}
      />

      <GuideSection
        icon={ChartBarIcon}
        title="Tabella Girone"
        content={`Visualizza e modifica i risultati del girone:

• Mostra tutti i risultati in una griglia
• Puoi inserire i punteggi toccando direttamente le celle
• Utile per gironi con molti partecipanti
• I risultati si aggiornano automaticamente
• Da qui puoi generare il tabellone di eliminazione`}
      />

      <GuideSection
        icon={TrophyIcon}
        title="Tabellone Eliminazione"
        content={`Dopo il girone, genera l'eliminazione diretta:

1. Vai alla schermata "Eliminazione"
2. Il sistema accoppia automaticamente gli atleti in base alla classifica
3. Tocca un match per inserire il risultato
4. I vincitori avanzano automaticamente al turno successivo`}
      />

      <GuideSection
        icon={MedalIcon}
        title="Classifica Finale"
        content={`Al termine della competizione:

• Visualizza la classifica completa
• Statistiche dettagliate per ogni partecipante`}
      />

      <GuideSection
        icon={TrendingUpIcon}
        title="Classifiche Girone"
        content={`Le classifiche del girone valgono per tutte le modalità:

• V/M = Vittorie / Match disputati
• TS = Stoccate Totali Date
• TR = Stoccate Totali Ricevute
• Ind = Indice (TS - TR)

La classifica determina gli accoppiamenti per l'eliminazione diretta.`}
      />

      <GuideSection
        icon={SmartphoneIcon}
        title="Navigazione"
        content={`Barra di navigazione in basso (visibile solo durante una gara):

• Config = Torna alla configurazione
• Assalti = Lista match da disputare
• Girone = Tabella risultati girone
• Elim. = Tabellone eliminazione
• Classifica = Classifica finale

Tocca l'icona Home in alto a sinistra per tornare alla home.`}
      />

      <GuideSection
        icon={LightbulbIcon}
        title="Suggerimenti Utili"
        content={`• L'app può essere scaricata dal menu del browser (Installa app)
• I dati vengono salvati automaticamente nel browser
• Puoi chiudere l'app e riprendere in seguito
• Per iniziare una nuova gara, torna alla home e seleziona una modalità
• Il sistema chiederà conferma prima di cancellare dati esistenti
• Funziona offline dopo il primo caricamento (PWA)
• Compatibile con smartphone, tablet e computer`}
      />


    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: '#f5f5f5',
  },
  header: {
    alignItems: 'center',
    marginTop: 24,
    marginBottom: 32,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#1976d2',
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: '#757575',
    textAlign: 'center',
    maxWidth: '80%',
  },
  backButton: {
    backgroundColor: '#e3f2fd',
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 8,
    marginBottom: 24,
    alignSelf: 'flex-start',
  },
  backButtonText: {
    color: '#1976d2',
    fontWeight: 'bold',
  },
  section: {
    marginBottom: 24,
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 16,
    color: '#1976d2',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
    paddingBottom: 8,
  },
  sectionContent: {
    fontSize: 16,
    lineHeight: 24,
    color: '#424242',
  },

});

export default GuidePage;
